import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ApiService } from 'shared/services/api.service';
import { RemoteLoginComponent } from './remote-login/remote-login.component';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RemoteLoginComponent],
  selector: 'user-tools',
  templateUrl: './user-tools.component.html',
  styleUrls: ['./user-tools.component.scss']
})
export class UserToolsComponent {

  @Input('user') user  


}
